export const GlobalComponent = {
  BASE_URL: 'https://dealszoapi.azurewebsites.net/api',
  //BASE_URL: 'http://localhost:5143/api',
};
